import theme from '@theme-ui/preset-tailwind';

export const borders = {
  ...(theme.borders && theme.borders),
};
export const borderWidths = {
  ...(theme.borderWidths && theme.borderWidths),
};
export const borderStyles = {
  ...(theme.borderStyles && theme.borderStyles),
};
